import React, { useEffect } from 'react';
import {
  useApiQuery,
  getFinancialInsights,
  getCompanyUuid,
  useApiMutation,
} from '@hum/api';
import { useUrlQuery } from '@hum/common/src/hooks/useUrlQuery';
import { MafiConnect } from './MafiConnect';
import { Spinner } from '@hum/ui-library';
import { useHistory } from 'react-router-dom';

export const MafiConnectPage = () => {
  const history = useHistory();
  const [{ company_id }] = useUrlQuery();
  const companyId = company_id;

  const { mutate: getUuid } = useApiMutation(getCompanyUuid, {
    onSuccess: (data) => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set('company_id', data.uuid);
      history.replace({ search: params.toString() });
    },
  });
  const { data: insights, isLoading: insightsLoading } = useApiQuery(
    getFinancialInsights,
    {
      params: {
        companyId: companyId,
      },
    }
  );

  useEffect(() => {
    const id = Number(companyId);
    if (!isNaN(id)) {
      getUuid({ companyId: id });
    }
  }, [companyId]);

  return !insightsLoading && insights ? (
    <MafiConnect insights={insights} />
  ) : (
    <Spinner fullScreen />
  );
};
